const accordion = () => {
    const wrappers = document.querySelectorAll('[data-accordion="wrapper"]');

    wrappers.forEach((wrapper) => {
        const accordions = wrapper.querySelectorAll('[data-accordion="accordion"]');
        let activeAccordion = null;

        if (accordions.length > 0) {
            const first = accordions[0];
            const firstControl = first.querySelector('[data-accordion="control"]');
            const firstContent = first.querySelector('[data-accordion="content"]');

            first.classList.add('is-open');
            firstControl.setAttribute('aria-expanded', 'true');
            firstContent.setAttribute('aria-hidden', 'false');
            first.querySelectorAll('[data-accordion="text"]').forEach(el => el.classList.add('active'));
            activeAccordion = first;
        }

        accordions.forEach((el) => {
            el.addEventListener('click', (e) => {
                const self = e.currentTarget;
                const control = self.querySelector('[data-accordion="control"]');
                const content = self.querySelector('[data-accordion="content"]');

                if (self === activeAccordion) {
                    self.classList.remove('is-open');
                    control.setAttribute('aria-expanded', 'false');
                    content.setAttribute('aria-hidden', 'true');
                    self.querySelectorAll('[data-accordion="text"]').forEach(el => el.classList.remove('active'));
                    activeAccordion = null;
                } else {
                    if (activeAccordion) {
                        const activeControl = activeAccordion.querySelector('[data-accordion="control"]');
                        const activeContent = activeAccordion.querySelector('[data-accordion="content"]');
                        activeAccordion.classList.remove('is-open');
                        activeControl.setAttribute('aria-expanded', 'false');
                        activeContent.setAttribute('aria-hidden', 'true');
                        activeAccordion.querySelectorAll('[data-accordion="text"]').forEach(el => el.classList.remove('active'));
                    }


                    self.classList.add('is-open');
                    control.setAttribute('aria-expanded', 'true');
                    content.setAttribute('aria-hidden', 'false');
                    self.querySelectorAll('[data-accordion="text"]').forEach(el => el.classList.add('active'));
                    activeAccordion = self;
                }


                content.addEventListener('click', (e) => e.stopPropagation());
            });
        });
    });
};

export default accordion;
